/**
 * Maps vertical wheel delta to a pixel delta for horizontal `scrollLeft`.
 * Honors `WheelEvent.deltaMode` (pixel / line / page) per UI Events.
 */
export function wheelDeltaYToHorizontalScrollPixels(
  nativeEvent: WheelEvent,
  scrollContainer: HTMLElement,
): number {
  const { deltaY, deltaMode } = nativeEvent;
  switch (deltaMode) {
    case WheelEvent.DOM_DELTA_PIXEL:
      return deltaY;
    case WheelEvent.DOM_DELTA_LINE: {
      const fontSize = parseFloat(getComputedStyle(scrollContainer).fontSize);
      const linePx =
        Number.isFinite(fontSize) && fontSize > 0 ? fontSize * 1.25 : 20;
      return deltaY * linePx;
    }
    case WheelEvent.DOM_DELTA_PAGE:
      return deltaY * scrollContainer.clientWidth;
    default:
      return deltaY;
  }
}
